module.exports = __webpack_public_path__ + "static/media/naiara.69b3a75e.jpg";